import {StyledProPhotoOfferingsWrapper} from './style'
import {useDialogStore} from '@ariakit/react/dialog'
import {RemappedOfferingProPhotos, RemappedServiceProPhotos} from '../../types'
import {ServiceProPhotosChangeOfferingPhotoModal} from '../service-pro-photos-change-offering-photo-modal/ServiceProPhotosChangeOfferingPhotoModal'
import {ProPhotosServiceCard} from '@/features/submission-pro-photos-upload/components/pro-photos-service-card/ProPhotosServiceCard'
import {useState} from 'react'

interface ServicesProPhotosOfferingsProps {
    service: RemappedServiceProPhotos
}
export const ServicesProPhotosOfferings = ({service}: ServicesProPhotosOfferingsProps) => {
    const changePhotoDialog = useDialogStore()
    const [selectedOffering, setSelectedOffering] = useState<RemappedOfferingProPhotos | null>(null)

    return (
        <>
            <StyledProPhotoOfferingsWrapper gap={4} direction="column" fullWidth>
                {service.offerings.map((offering, index) => (
                    <ProPhotosServiceCard
                        key={index}
                        title={offering.questionAnswer.title.answer}
                        description={offering.questionAnswer.description.answer}
                        onCardClick={() => {
                            setSelectedOffering(offering)
                            changePhotoDialog.toggle()
                        }}
                        coverImageUrl={offering.mainPhotoUrl}
                    />
                ))}
            </StyledProPhotoOfferingsWrapper>

            {selectedOffering != null && (
                <ServiceProPhotosChangeOfferingPhotoModal
                    serviceId={service.id}
                    galleryId={service.gallery.id}
                    store={changePhotoDialog}
                    offeringId={selectedOffering.id}
                    offeringTitle={selectedOffering.questionAnswer.title.answer}
                    onClose={() => {
                        setSelectedOffering(null)
                        changePhotoDialog.toggle()
                    }}
                    mainPhotoId={selectedOffering.imageId}
                />
            )}
        </>
    )
}
